import React, { useState } from "react";

export default function MahilaMandiContractMfgForm() {
  const [supplierName, setSupplierName] = useState("");
  const [supplierType, setSupplierType] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [village, setVillage] = useState("");
  const [stateDistrict, setStateDistrict] = useState("");
  const [productType, setProductType] = useState("");
  const [productName, setProductName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [productionDate, setProductionDate] = useState("");
  const [natural, setNatural] = useState("");
  const [certifications, setCertifications] = useState([]);
  const [price, setPrice] = useState("");
  const [deliveryType, setDeliveryType] = useState("");
  const [packaging, setPackaging] = useState("");
  const [minOrder, setMinOrder] = useState("");
  const [longTerm, setLongTerm] = useState("");
  const [notes, setNotes] = useState("");
  const [showAbout, setShowAbout] = useState(false);

  const supplierTypes = [
    "Individual Artisan",
    "Women Cooperative",
    "Home-Based Producer",
    "Craft Group",
    "NGO Supported",
    "Family Workshop"
  ];
  const productTypes = [
    "Pickles & Preserves",
    "Handmade Soaps",
    "Baked Goods",
    "Herbal Teas",
    "Textiles",
    "Jewelry",
    "Candles",
    "Pottery",
    "Handicrafts",
    "Others"
  ];
  const deliveryOptions = [
    "Pickup from Artisan",
    "Home Delivery",
    "Local Market",
    "Courier Service",
    "Bulk Shipment",
    "Export Ready"
  ];
  const certOptions = [
    "Fair Trade",
    "Organic Ingredients",
    "Artisan Verified",
    "Handmade Cert",
    "Eco-Friendly",
    "Women Empowered",
    "Other"
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!productType || !productName || !quantity || !supplierName || !pinCode) {
      alert("Please fill all required fields (Supplier Name, Product Type, Product Name, Quantity, PIN).");
      return;
    }

    alert(`Contract Manufacturing Lead Submitted:
Supplier Name: ${supplierName}
Supplier Type: ${supplierType}
PIN: ${pinCode}
Village: ${village}
State/District: ${stateDistrict}
Product Type: ${productType}
Product Name: ${productName}
Quantity: ${quantity}
Production Date: ${productionDate}
Natural/Handmade: ${natural}
Certifications: ${certifications.join(", ")}
Price Expectation: ${price}
Delivery Type: ${deliveryType}
Packaging: ${packaging}
Minimum Order: ${minOrder}
Long Term Contract: ${longTerm}
Notes: ${notes}`);
  };

  const handleCertificationChange = (cert) => {
    setCertifications((prev) =>
      prev.includes(cert) ? prev.filter((c) => c !== cert) : [...prev, cert]
    );
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-black shadow-lg rounded-2xl relative">
      <h2 className="text-xl font-bold mb-4 text-yellow-200">MahilaMandi Contract Manufacturing Lead Form</h2>

      {/* About Button */}
      <button
        type="button"
        onClick={() => setShowAbout(true)}
        className="mb-4 bg-purple-600 w-full text-white px-4 py-2 rounded hover:bg-purple-700"
      >
        About MahilaMandi Contract Manufacturing
      </button>

      {/* About Modal */}
      {showAbout && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-black border border-green-500 p-6 rounded-2xl max-w-2xl shadow-xl overflow-y-auto max-h-[80vh]">
            <h3 className="text-2xl font-bold mb-4 text-center text-yellow-100">
              About Contract Mahila Udyog Manufacturing
            </h3>
            <div className="space-y-4 text-white text-sm leading-relaxed">
              <p>
                Contract manufacturing allows women artisans, cooperatives, and home-based producers to offer handmade products to
                buyers under agreed terms. It ensures better market access, fair pricing,
                and predictable demand for both parties while empowering women-led enterprises.
              </p>
              <p>
                <b>MahilaMandi Contract Manufacturing Module</b> helps artisans submit leads, negotiate terms,
                and get connected with verified buyers efficiently.
              </p>
            </div>
            <div className="mt-6 text-center">
              <button
                onClick={() => setShowAbout(false)}
                className="bg-red-600 text-white px-4 py-2 w-24 rounded hover:bg-red-700"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-4 lg:max-w-4xl text-white">
        {/* Supplier Name & Type */}
        <div>
          <label className="block font-medium mb-1">Supplier / Artisan Name *</label>
          <input
            type="text"
            value={supplierName}
            onChange={(e) => setSupplierName(e.target.value)}
            placeholder="Enter supplier or artisan name"
            style={{width: "100%"}}
            className="h-10 w-full border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Type</label>
          <select
            value={supplierType}
            onChange={(e) => setSupplierType(e.target.value)}
            className="h-10 border p-2 rounded text-black"
          >
            <option value="">-- Choose Type --</option>
            {supplierTypes.map((type) => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        {/* Location */}
        <div>
          <label className="block font-medium mb-1">PIN Code *</label>
          <input
            type="text"
            value={pinCode}
            onChange={(e) => setPinCode(e.target.value)}
            placeholder="Enter PIN Code"
            className="border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Village / Area</label>
          <input
            type="text"
            value={village}
            onChange={(e) => setVillage(e.target.value)}
            placeholder="Enter village or area"
            className="w-full border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">State / District</label>
          <input
            type="text"
            value={stateDistrict}
            onChange={(e) => setStateDistrict(e.target.value)}
            placeholder="Enter state or district"
            className="w-full border p-2 rounded text-black"
          />
        </div>

        {/* Product Details */}
        <div>
          <label className="block font-medium mb-1">Product Type *</label>
          <select
            value={productType}
            onChange={(e) => setProductType(e.target.value)}
            className="h-10 border p-2 rounded text-black"
          >
            <option value="">-- Choose Product Type --</option>
            {productTypes.map((type) => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block font-medium mb-1">Product Name / Variety *</label>
          <input
            type="text"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            placeholder="Enter product name or variety (e.g., Mango Pickle, Lavender Soap)"
            className="h-10 w-full border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Expected Quantity / Batch Size *</label>
          <input
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            placeholder="Enter expected quantity or batch size"
            className="h-10 border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Expected Production Date</label>
          <input
            type="month"
            value={productionDate}
            onChange={(e) => setProductionDate(e.target.value)}
            className="h-10 border p-2 rounded text-black"
          />
        </div>

        {/* Natural & Certifications */}
        <div>
          <label className="block font-medium mb-1">Natural / Handmade</label>
          <select
            value={natural}
            onChange={(e) => setNatural(e.target.value)}
            className="h-10 border p-2 rounded text-black"
          >
            <option value="">-- Select --</option>
            <option value="Natural">Natural</option>
            <option value="Handmade">Handmade</option>
            <option value="Eco-Friendly">Eco-Friendly</option>
            <option value="Conventional">Conventional</option>
          </select>
        </div>
        <div>
          <label className="block font-medium mb-1">Certifications</label>
          <div className="flex flex-wrap gap-2">
            {certOptions.map((cert) => (
              <label key={cert} className="bg-gray-300 px-2 py-1 rounded text-black cursor-pointer">
                <input
                  type="checkbox"
                  checked={certifications.includes(cert)}
                  onChange={() => handleCertificationChange(cert)}
                  className="mr-1"
                />
                {cert}
              </label>
            ))}
          </div>
        </div>

        {/* Price & Delivery */}
        <div>
          <label className="block font-medium mb-1">Price Expectation (optional)</label>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="Price per unit / batch (optional)"
            className="h-10 border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Preferred Delivery Type</label>
          <select
            value={deliveryType}
            onChange={(e) => setDeliveryType(e.target.value)}
            className="h-10 border p-2 rounded text-black"
          >
            <option value="">-- Choose Delivery Type --</option>
            {deliveryOptions.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block font-medium mb-1">Packaging Type</label>
          <input
            type="text"
            value={packaging}
            onChange={(e) => setPackaging(e.target.value)}
            placeholder="Bulk / Retail / Custom / Export Ready"
            className="h-10 border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Minimum Order Quantity</label>
          <input
            type="number"
            value={minOrder}
            onChange={(e) => setMinOrder(e.target.value)}
            placeholder="Enter minimum order quantity"
            className="h-10 border p-2 rounded text-black"
          />
        </div>
        <div>
          <label className="block font-medium mb-1">Interested in Long-Term Contract</label>
          <select
            value={longTerm}
            onChange={(e) => setLongTerm(e.target.value)}
            className="h-10 border p-2 rounded text-black"
          >
            <option value="">-- Select --</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>

        {/* Notes */}
        <div>
          <label className="block font-medium mb-1">Notes / Special Requirements</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Enter any additional information (e.g., custom designs, bulk customization)"
            style={{height: "300px", width: "100%"}}
            className="w-full border p-2 rounded bg-gray-200 text-black"
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-green-600 text-white w-20 px-4 py-2 rounded hover:bg-green-700"
        >
          Submit
        </button>
      </form>
    </div>
  );
}